(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.clientLogging = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = _exports.logging = void 0;
  // Expedia remote client logger
  // ----------------------------
  //
  // Requires the following javascript variables which are set in ClientLoggingTag.ftl:
  //
  // dctk.logging.pageStartTime
  // dctk.logging.pageName - pageName
  var dctk = typeof window !== 'undefined' && window.dctk || {};
  dctk.logging = dctk.logging || {};

  (function () {
    "use strict";

    if (typeof window === 'undefined') {
      return;
    } // Bail out if not in browser environment


    if (dctk.logging.enabled == null) {
      dctk.logging.enabled = true;
    } // Enabled by default


    if (!dctk.logging.enabled) {
      return;
    } //modified from orig clientlogging js to include expedia domain


    var perfBeaconUrl = "//www.expedia.com/cl/1x1.gif",
        messageBeaconUrl = "//www.expedia.com/cl/2x2.gif",
        reportedErrors = {},
        onerrorSubscribers = [];
    var dataBrowser = [{
      string: navigator.userAgent,
      subString: "Chrome",
      identity: "Chrome"
    }, {
      string: navigator.userAgent,
      subString: "OmniWeb",
      versionSearch: "OmniWeb/",
      identity: "OmniWeb"
    }, {
      string: navigator.vendor,
      subString: "Apple",
      identity: "Safari",
      versionSearch: "Version"
    }, {
      prop: window.opera,
      identity: "Opera"
    }, {
      string: navigator.vendor,
      subString: "iCab",
      identity: "iCab"
    }, {
      string: navigator.vendor,
      subString: "KDE",
      identity: "Konqueror"
    }, {
      string: navigator.userAgent,
      subString: "Firefox",
      identity: "Firefox"
    }, {
      string: navigator.vendor,
      subString: "Camino",
      identity: "Camino"
    }, {
      // for newer Netscapes (6+)
      string: navigator.userAgent,
      subString: "Netscape",
      identity: "Netscape"
    }, {
      string: navigator.userAgent,
      subString: "MSIE",
      identity: "Explorer",
      versionSearch: "MSIE"
    }, {
      string: navigator.userAgent,
      subString: "Gecko",
      identity: "Mozilla",
      versionSearch: "rv"
    }, {
      // for older Netscapes (4-)
      string: navigator.userAgent,
      subString: "Mozilla",
      identity: "Netscape",
      versionSearch: "Mozilla"
    }];
    var dataOS = [{
      string: navigator.userAgent,
      subString: "iPad",
      identity: "iPad"
    }, {
      string: navigator.userAgent,
      subString: "iPhone",
      identity: "iPhone/iPod"
    }, {
      string: navigator.userAgent,
      subString: "Kindle",
      identity: "Kindle"
    }, {
      string: navigator.userAgent,
      subString: "BB10",
      identity: "Blackberry"
    }, {
      string: navigator.userAgent,
      subString: "Touch",
      addlString: "MSIE 10",
      identity: "Surface"
    }, {
      string: navigator.userAgent,
      subString: "Android",
      identity: "Android"
    }, {
      string: navigator.platform,
      subString: "Win",
      identity: "Windows"
    }, {
      string: navigator.platform,
      subString: "Mac",
      identity: "Mac"
    }, {
      string: navigator.userAgent,
      subString: "iPhone",
      identity: "iPhone/iPod"
    }, {
      string: navigator.platform,
      subString: "Linux",
      identity: "Linux"
    }];
    var productionDomains = ['account.expediapartnercentral.com', 'api.expediapartnercentral.com', 'apm.expediapartnercentral.com', 'apps.expediapartnercentral.com', 'contentadmin.expediapartnercentral.com', 'he.expediapartnercentral.com', 'hotelcontent.expediapartnercentral.com', 'photos.expediapartnercentral.com', 'promotions.expediapartnercentral.com', 'roomsandrates.expediapartnercentral.com', 'travelads.expediapartnercentral.com', 'www.expediapartnercentral.com', 'conversations.expedia.com', 'conversations.hotels.com', 'conversations.orbitz.com', 'conversations.travelocity.com', 'conversations.wotif.com', 'conversations.egencia.com', 'www.expedia.com', 'www.hotels.com', 'www.orbitz.com', 'www.travelocity.com', 'www.wotif.com', 'www.egencia.com', 'www.ebookers.com', 'www.mytravelchat.com'];
    /**
     * @param {Object} [params]
     * @param {String} [params._domain] The domain to check or `domain` by default
     * @param {Array<String|RegExp>} [params._productionDomains] The list of domains in production
     * @return {boolean} Is the domain in production?
     */

    dctk.logging._isAProductionDomain = function (params) {
      params = params || {};
      params._domain = params._domain || domain;
      params._productionDomains = params._productionDomains || productionDomains;

      for (var i = 0, len = params._productionDomains.length; i < len; i++) {
        if (params._domain === params._productionDomains[i]) {
          return true;
        }
      }

      return false;
    };

    var searchString = function searchString(data) {
      var dataString, dataProp;

      for (var i = 0; i < data.length; i++) {
        dataString = data[i].string;
        dataProp = data[i].prop;
        dctk.logging.versionSearchString = data[i].versionSearch || data[i].identity;

        if (dataString) {
          if (dataString.indexOf(data[i].subString) !== -1 && (!data[i].addlString || dataString.indexOf(data[i].addlString) !== -1)) {
            return data[i].identity || "unknown";
          }
        } else if (dataProp) {
          return data[i].identity || "unknown";
        }
      }
    };

    var searchVersion = function searchVersion(dataString) {
      var index = dataString.indexOf(dctk.logging.versionSearchString);

      if (index === -1) {
        return;
      }

      return parseFloat(dataString.substring(index + dctk.logging.versionSearchString.length + 1));
    };

    var expGetISODateString = function expGetISODateString(date) {
      if (date.toISOString) {
        return date.toISOString();
      } else {
        return date.getFullYear().toString() + "-" + date.getMonth() + "-" + date.getDate() + "T" + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
      }
    };

    var domReady = function domReady(win, fn) {
      /*
          *
          * Author: Diego Perini (diego.perini at gmail.com)
          * Summary: cross-browser wrapper for DOMContentLoaded
          * Updated: 20101020
          * License: MIT
          * Version: 1.2
          *
          * URL:
          * http://javascript.nwbox.com/ContentLoaded/
          * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
          *
          */
      var done = false,
          top = true,
          doc = win.document,
          root = doc.documentElement,
          add = doc.addEventListener ? 'addEventListener' : 'attachEvent',
          rem = doc.addEventListener ? 'removeEventListener' : 'detachEvent',
          pre = doc.addEventListener ? '' : 'on',
          init = function init(e) {
        if (e.type === 'readystatechange' && doc.readyState !== 'complete') {
          return;
        }

        (e.type === 'load' ? win : doc)[rem](pre + e.type, init, false);

        if (!done && (done = true)) {
          fn.call(win, e.type || e);
        }
      },
          poll = function poll() {
        try {
          root.doScroll('left');
        } catch (e) {
          setTimeout(poll, 50);
          return;
        }

        init('poll');
      };

      if (doc.readyState === 'complete') {
        fn.call(win, 'lazy');
      } else {
        if (doc.createEventObject && root.doScroll) {
          try {
            top = !win.frameElement;
          } catch (e) {}

          if (top) {
            poll();
          }
        }

        doc[add](pre + 'DOMContentLoaded', init, false);
        doc[add](pre + 'readystatechange', init, false);
        win[add](pre + 'load', init, false);
      }
    };

    var addEvent = function addEvent(obj, type, fn) {
      if (obj.attachEvent) {
        obj['e' + type + fn] = fn;

        obj[type + fn] = function () {
          obj['e' + type + fn](window.event);
        };

        obj.attachEvent('on' + type, obj[type + fn]);
      } else {
        obj.addEventListener(type, fn, false);
      }
    };

    var sendParams = function sendParams(params) {
      var beacon = new Image();
      beacon.src = perfBeaconUrl + fixedParams + "&pageName=" + dctk.logging.pageName + "&guid=" + getGuid() + "&requestId=" + getRequestId() + "&serverEnvironment=" + getServerEnvironment() + "&applicationName=" + getApplicationName() + "&logTime=" + expGetISODateString(new Date()) + "&action=logTrxEvent&" + params.join("&");
      beacons.push(beacon); // Hold the reference to the new image so IE will bother to fetch the src.
    };

    var getGuid = function getGuid() {
      return dctk.logging.guid || "unknown";
    };

    var getServerEnvironment = function getServerEnvironment() {
      return dctk.logging.serverEnvironment || "unknown";
    };

    var getRequestId = function getRequestId() {
      return dctk.logging.requestId || "unknown";
    };

    var getApplicationName = function getApplicationName() {
      return dctk.logging.applicationName || "unknown";
    };

    var sendMessage = function sendMessage(params) {
      var beacon = new Image();
      beacon.src = messageBeaconUrl + fixedParams + "&pageName=" + dctk.logging.pageName + "&guid=" + getGuid() + "&requestId=" + getRequestId() + "&serverEnvironment=" + getServerEnvironment() + "&applicationName=" + getApplicationName() + "&logTime=" + expGetISODateString(new Date()) + "&action=logErrors&" + params.join("&");
      beacons.push(beacon); // Hold the reference to the new image so IE will bother to fetch the src.
    };
    /**
     * @param {string} name The name of the property of `performance.timing`
     * @returns {number|NaN} Its value or `NaN` if it doesn't exist (e.g. because
     *     the browser doesn't support the Navigation Timing API) or it's `0`,
     *     (which is the default value when the property could not be calculated)
     */


    var getTiming = function getTiming(name) {
      return window.performance && performance.timing && performance.timing[name] || NaN;
    };
    /**
     * @returns {Object} The list of timing intervals. The actual interval will be
     *     `NaN` in case it can't be computed.
     */


    var getNavTimingData = function getNavTimingData() {
      return {
        unloadTime: getTiming('unloadEventEnd') - getTiming('unloadEventStart'),
        redirectTime: getTiming('redirectEnd') - getTiming('redirectStart'),
        dnsTime: getTiming('domainLookupEnd') - getTiming('domainLookupStart'),
        connectionTime: getTiming('connectEnd') - getTiming('connectStart'),
        requestTime: getTiming('responseStart') - getTiming('requestStart'),
        responseTime: getTiming('responseEnd') - getTiming('responseStart'),
        parsingTime: getTiming('domInteractive') - getTiming('domLoading'),
        domReadyCallbackTime: getTiming('domContentLoadedEventEnd') - getTiming('domContentLoadedEventStart'),
        onLdCallbackTime: getTiming('loadEventEnd') - getTiming('loadEventStart'),
        processingTime: getTiming('domComplete') - getTiming('domLoading'),
        navigationToResponse: getTiming('responseStart') - getTiming('navigationStart'),
        navigationToDomContentLoaded: getTiming('domContentLoadedEventStart') - getTiming('navigationStart'),
        navigationToOnLd: getTiming('loadEventStart') - getTiming('navigationStart'),
        fetchToResponse: getTiming('responseStart') - getTiming('fetchStart'),
        fetchToDomContentLoaded: getTiming('domContentLoadedEventStart') - getTiming('fetchStart'),
        fetchToOnLd: getTiming('loadEventStart') - getTiming('fetchStart'),
        responseToDomContentLoaded: getTiming('domContentLoadedEventStart') - getTiming('responseStart'),
        responseToOnLd: getTiming('loadEventStart') - getTiming('responseStart'),
        navigationToDomInteractive: getTiming('domInteractive') - getTiming('navigationStart')
      };
    };

    var reportNavTimingData = function reportNavTimingData(timing) {
      if (!("responseToOnLd" in timing)) {
        return;
      } // make sure the important timings are actually there TODO Is it needed?


      var params = [];

      for (var name in timing) {
        var value = timing[name];

        if (isNaN(value)) {
          continue;
        } // Skip the timings that could not be computed


        params.push(name + "=" + value);
      }

      if (!params.length) {
        return;
      }

      dctk.logging.logTrxEvent('navTiming', params.join('&'));
    };

    var browser = searchString(dataBrowser);
    var version = searchVersion(navigator.userAgent) || searchVersion(navigator.appVersion) || "an unknown version";
    var domain = window.location.hostname;
    var applicationUrl = encodeURIComponent(window.location.href);
    var OS = searchString(dataOS);
    var dataParams = '';
    var domReadyParam = [];

    if (dctk.logging.data) {
      for (var i = 0, dataList = dctk.logging.data.split("|"); i < dataList.length && dataList[i].length > 0; i++) {
        dataParams += "&" + dataList[i];
      }
    }

    var beacons = [],
        // holds reference to beacon images to ensure IE fetches the src
    fixedParams = "?browser=" + browser + "&browserVersion=" + version + "&platform=" + OS + "&domain=" + domain + "&live=" + dctk.logging._isAProductionDomain() + "&applicationUrl=" + applicationUrl + dataParams;

    if ("performance" in window) {
      addEvent(window, 'load', function () {
        window.setTimeout(function () {
          // Delay a little past onLoad in order to get onLoad callback timing
          dctk.logging.navTiming = getNavTimingData();
          reportNavTimingData(dctk.logging.navTiming);
        }, 1000);
      }); // Set start time to navigation start

      dctk.logging.pageStartTime = window.performance.timing.responseStart;
    } else {
      // If not set using nav timing, or externally, set start time to now
      dctk.logging.pageStartTime = dctk.logging.pageStartTime || new Date().getTime();
      addEvent(window, 'load', function () {
        var param = domReadyParam.concat(['responseToOnLd=' + (new Date().getTime() - dctk.logging.pageStartTime)]);
        sendParams(param);
      });
      domReady(window, function () {
        domReadyParam = ['responseToDomContentLoaded=' + (new Date().getTime() - dctk.logging.pageStartTime)];
      });
    } // Public vars and methods


    dctk.logging.navTiming = {};
    dctk.logging.browser = browser;
    dctk.logging.version = version;
    dctk.logging.OS = OS;
    /**
     * Logs custom performance data
     *
     * Several pairs of keys are available to log custom performance
     * data, unrecognized key/value pairs will be discarded:
     *
     * - `clEventName01`/`clEventTime01`
     * - `clEventName02`/`clEventTime02`
     * - `clEventName03`/`clEventTime03`
     * - `clEventName04`/`clEventTime04`
     *
     * Example:
     *
     * ```js
     * var returningStartTime = new Date().getTime();
     *
     * // Do the stuff you're measuring...
     *
     * dctk.logging.logTrxEvent("getReturningModules", [
     *      'clEventName01=getReturningModules',
     *      'clEventTime01=' + (new Date().getTime() - returningStartTime)
     * ]);
     * ```
     *
     * Refer to [client side logging documentation](../../../../../../docs/client-logging.md)
     * for more details.
     *
     * @api
     * @param {string} label
     * @param {string|Array.<string>} [additionalData]
     */

    dctk.logging.logTrxEvent = function (label, additionalData) {
      var params = [label + "_elapsedTime=" + (new Date().getTime() - dctk.logging.pageStartTime)];

      if (additionalData) {
        params = params.concat(additionalData);
      }

      sendParams(params);
    };
    /**
     * @api
     * @param {Function} fn
     * @param {string} label
     * @param {Object} context
     */


    dctk.logging.trxEventWrapper = function (fn, label, context) {
      return function () {
        var startFnTime = new Date().getTime();
        var retval = fn.apply(context ? context : this, arguments);
        var timeNow = new Date().getTime();
        sendParams([label + "_elapsedTime=" + (timeNow - dctk.logging.pageStartTime), "clEventName01=" + label, "clEventTime01=" + (timeNow - startFnTime)]);
        return retval;
      };
    };
    /**
     * Logs a custom message
     *
     * Example where an Ajax error is logged:
     *
     * ```js
     * $.ajax('/baggage-fees.json').
     *     done(function (data) { ... }).
     *     fail(function (xhr, status, error) {
    *         dctk.logging.logMessage('getBaggageFeesJsonAjaxError', {
    *             status: status,
    *             error: error,
    *             fnTime: new Date().getTime() - ModuleBuilder.Controller.baggageFeesStartTime
    *         });
    *     });
     * ```
     *
     * Refer to [client side logging documentation](../../../../../../docs/client-logging.md)
     * for more details.
     *
     * @api
     * @param {string} label
     * @param {Object.<string,string>|Array.<string>|string} [additionalData] Any
     *     additional key/value pairs to attach to the message. Object format is
     *     recommended (see example) as array (`['field1=value1', 'field2=value2']`)
     *     and string (`'field1=value1&field2=value2'`) formats won't escape the
     *     parameters, possibly resulting in bogus data.
     */


    dctk.logging.logMessage = function (label, additionalData) {
      var params = [].concat(this._normalizeMessageParams(function () {
        var params = {
          label: label
        };
        params[label + '_elapsedTime'] = new Date().getTime() - dctk.logging.pageStartTime;
        return params;
      }())).concat(this._normalizeMessageParams(additionalData));

      if (label === "windowOnError") {
        var errorMsg = additionalData[0]; // If this error message has not been previously logged.

        if (!(errorMsg in reportedErrors)) {
          reportedErrors[errorMsg] = {
            "count": 0
          }; // Log the first occurrence of the error.

          sendMessage(params);
        } // Increment the error count.


        reportedErrors[errorMsg].count = parseInt(reportedErrors[errorMsg].count, 10) + 1; // If the error message has occurred at least a hundred times, log that it has exceeded the threshold.

        if (reportedErrors[errorMsg].count === 100) {
          sendMessage(params.concat("exceedsErrorThreshold=true"));
        }
      } else {
        sendMessage(params);
      }
    };

    dctk.logging.normalizeError = function (e) {
      var NA = 'NA',
          col = NA,
          line = NA,
          src = NA,
          loc;

      try {
        if (e && e.stack) {
          loc = e.stack.match(/\(([^\)]+\d+)\)/);

          if (!loc) {
            loc = e.stack.match(/@([^\)]+\d+)\n/);
          }

          if (loc) {
            loc = loc[1].split(':');
            col = loc.pop();
            line = loc.pop();
            src = loc.join(':');
          }
        }
      } catch (ex) {//do nothing and return the error as is
      }

      if (e) {
        e = {
          sourceURL: e.sourceURL || e.fileName || src,
          line: e.line || e.lineNumber || line,
          col: e.columnNumber || col,
          message: e.message,
          stack: e.stack || NA
        };
      }

      return e;
    };
    /* @description logs errors to client-side logging using dctk.logMessage().
        * @param errorLabel is a string giving the error a label.
        * @param error is a JavaScript error object.
        * @param additionalParams is an array of strings.
        */


    dctk.logging.logError = function (errorLabel, error, additionalParams) {
      // Fail fast if the caller hasn't provided the right information
      if (!errorLabel || !error) {
        return;
      }

      var debugInfo = []; // Additional Parameters the caller has asked to be included in the message

      if ('[object Array]' === Object.prototype.toString.call(additionalParams)) {
        debugInfo = debugInfo.concat(additionalParams);
      }

      error = this.normalizeError(error); // Infomation we can get reliably from the error object

      if (error) {
        debugInfo.push("onErrorMsg=" + error.message);
        debugInfo.push("onErrorLine=" + error.line);
        debugInfo.push("onErrorChar=" + error.col);
        debugInfo.push("onErrorUrl=" + encodeURIComponent(error.sourceURL));

        if (error.stack) {
          debugInfo.push("stack=" + encodeURIComponent(error.stack.substr(0, 200)));
        }
      } else {
        debugInfo.push("onError=NA");
      } // Information about the environment


      debugInfo.push("pageUrl=" + encodeURIComponent(window.location.href));
      debugInfo.push("clientWidth=" + document.documentElement.clientWidth); // Log it to the console if it is available. This will let devs investigate issues

      if (window.console) {
        if (typeof console.error === 'function') {
          console.error(errorLabel + ": " + debugInfo.join('|'));
        } else if (typeof console.log === 'function') {
          console.log(errorLabel + ": " + debugInfo.join('|'));
        }
      } // Log to client side splunk via dctk


      dctk.logging.logMessage(errorLabel, debugInfo);
    };

    dctk.logging.reset = function () {
      dctk.logging.pageStartTime = new Date().getTime();
    };

    dctk.logging.subscribeToOnerrorCallback = function (fn) {
      onerrorSubscribers.push(fn);
    };

    dctk.logging.publishOnerrorCallback = function () {
      for (var i = 0; i < onerrorSubscribers.length; i++) {
        if (typeof onerrorSubscribers[i] === "function") {
          onerrorSubscribers[i]();
        }
      }
    };

    dctk.logging.setPageName = function (pageName) {
      dctk.logging.pageName = pageName;
    }; // Accessible so we can double it during testing


    dctk.logging._originalOnError = window.onerror; // Log unhandled Javascript errors

    window.onerror = function (msg, url, line) {
      // Enable browser default behaviour (i.e. to log the error on the console)
      // Also, it warns of any unhandled error during testing.
      if (dctk.logging._originalOnError) {
        dctk.logging._originalOnError.apply(window, arguments);
      }

      var width = 0;

      if (document.documentElement) {
        width = document.documentElement.clientWidth;
      }

      msg = msg.replace(/\'/ig, "`");
      msg = escape(msg);
      dctk.logging.logMessage("windowOnError", ["onErrorMsg=" + encodeURIComponent(msg), "onErrorUrl=" + encodeURIComponent(url), "onErrorLine=" + line, "clientWidth=" + width]);
      dctk.logging.publishOnerrorCallback();
    };

    dctk.loggingAdapter = dctk.logging; // Deprecated interface

    /**
     * @param {Object.<string,string>|Array.<string>|string|null} params
     * @return {Array}
     */

    dctk.logging._normalizeMessageParams = function (params) {
      if (!params) {
        return [];
      }

      if (typeof params === 'string') {
        return [params];
      }

      if (!(params instanceof Array)) {
        // Is it an object?
        var array = [];

        for (var name in params) {
          array.push(encodeURIComponent(name) + '=' + encodeURIComponent(params[name]));
        }

        params = array;
      }

      return params;
    };
  })();

  var logging = dctk.logging;
  _exports.logging = logging;
  var _default = dctk;
  _exports["default"] = _default;
});